import { render, staticRenderFns } from "./NumberLineMarker.vue?vue&type=template&id=5c213461&scoped=true&"
import script from "./NumberLineMarker.vue?vue&type=script&lang=js&"
export * from "./NumberLineMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c213461",
  null
  
)

export default component.exports